import { render } from "./tab-process.vue?vue&type=template&id=f759ba42&scoped=true&ts=true"
import script from "./tab-process.vue?vue&type=script&lang=ts"
export * from "./tab-process.vue?vue&type=script&lang=ts"

import "./tab-process.vue?vue&type=style&index=0&id=f759ba42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f759ba42"]])

export default __exports__